import { render, staticRenderFns } from "./DashboardCharts.vue?vue&type=template&id=4d89bf00&scoped=true"
import script from "./DashboardCharts.vue?vue&type=script&lang=js"
export * from "./DashboardCharts.vue?vue&type=script&lang=js"
import style0 from "./DashboardCharts.vue?vue&type=style&index=0&id=4d89bf00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d89bf00",
  null
  
)

export default component.exports